import type { ReactNode } from "react";

// Setul de icoane și marca, portate din prototipul din `mock-ui/app` — aceleași
// contururi, ca UI-ul real și planșele de design să nu diveargă.
const PATHS: Record<string, string> = {
  home: "M3.5 9.5 10 4l6.5 5.5 M5.5 9.5V16h9V9.5",
  doc: "M5 2.5h7l3.5 3.5v11.5H5V2.5z M12 2.5V6h3.5",
  gear: "M10 7a3 3 0 100 6 3 3 0 000-6z M10 2.5v2.4M10 15.1v2.4M2.5 10h2.4M15.1 10h2.4M4.7 4.7l1.7 1.7M13.6 13.6l1.7 1.7M15.3 4.7l-1.7 1.7M6.4 13.6l-1.7 1.7",
  pen: "M4 16.5h3.4L16 7.9 12.6 4.5 4 13.1v3.4z M11.8 5.3l3.4 3.4",
  plus: "M10 4v12M4 10h12",
  // ▶ „pornește generarea de pe nodul ăsta" și ⟲ „pornește-o din nou". Două
  // glife, nu unul: pe un board în care jumătate din carduri au deja urmași,
  // diferența dintre «se face acum» și «se face DIN NOU» trebuie văzută fără
  // să citești eticheta.
  play: "M6.6 4.3 15.6 10l-9 5.7V4.3z",
  redo: "M16 10a6 6 0 10-2.2 4.6 M16 6.4V10h-3.6",
  // ■ „oprește rularea". Pătratul plin e semnul universal de stop, iar aici
  // trebuie să se citească la 12 px, lângă «Pasul 7/16».
  stop: "M6.5 6.5h7v7h-7z",
  x: "M5 5l10 10M15 5 5 15",
  users: "M7 9.5a3 3 0 100-6 3 3 0 000 6z M2 16.5c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5 M13.5 12.2c2 .5 3.5 2.2 3.5 4.3 M13 9.4a3 3 0 000-5.8",
  logout: "M12.5 6V4H4v12h8.5v-2 M8.5 10H17 M14 7l3 3-3 3",
  arrow: "M4 10h12M11 5l5 5-5 5",
  back: "M16 10H4M9 5l-5 5 5 5",
  caret: "M6.5 8.5 10 12l3.5-3.5",
  upload: "M10 13V4 M6.5 7.5 10 4l3.5 3.5 M4 13.5v3h12v-3",
  /** Exportul: săgeata în jos, în tavă — perechea lui `upload`. */
  download: "M10 4v9 M6.5 9.5 10 13l3.5-3.5 M4 13.5v3h12v-3",
  org: "M4 17V4h8v13 M12 8h4v9 M2.5 17h15 M6.5 7h1.5 M6.5 10h1.5 M6.5 13h1.5",
  // Ce primește un proiect, câte o icoană pe livrabil — v. `pages/ProiectNou`.
  situatie: "M2.5 4.5h15v11h-15z M5.5 7.5h6v5h-6z M14 10.5a1.4 1.4 0 1 0 2.8 0a1.4 1.4 0 1 0-2.8 0",
  fatada: "M4.5 17.5V5.5h11v12 M2.5 17.5h15 M7 8h2v2H7z M11 8h2v2h-2z M7 12h2v2H7z M11 12h2v2h-2z",
  apartamente: "M3 3.5h14v13H3z M10 3.5v6 M3 9.5h14 M13 9.5v7",
  subsol: "M2.5 5h15 M2.5 15h15 M6.5 5v3.5 M10 5v3.5 M13.5 5v3.5 M6.5 15v-3.5 M10 15v-3.5 M13.5 15v-3.5",
  structura: "M5 17V3 M15 17V3 M5 4.5h10 M5 10.5h10 M3 17h14",
  sanitare: "M10 3.2c2.8 3.6 4.6 6.2 4.6 8.6a4.6 4.6 0 0 1-9.2 0c0-2.4 1.8-5 4.6-8.6z",
  electrice: "M7.5 3v3.5 M12.5 3v3.5 M5.5 6.5h9v3a4.5 4.5 0 0 1-9 0z M10 14v3.5",
  hvac: "M3 7.5h8.5a2.5 2.5 0 1 0-2.5-2.5 M3 11h11.5a2.5 2.5 0 1 1-2.5 2.5 M3 14.5h5",
  deviz: "M5 2.5h10v15l-1.7-1.1-1.6 1.1-1.7-1.1-1.7 1.1-1.6-1.1L5 17.5z M8 6.5h4 M8 9.5h4 M8 12.5h2.5",
  bolt: "M11 2 4 11.5h5L8 18l7-9.5h-5L11 2z",
  bug: "M10 7a3.5 3.5 0 013.5 3.5v2.5a3.5 3.5 0 01-7 0v-2.5A3.5 3.5 0 0110 7z M8 7a2 2 0 014 0 M10 9v7.5 M6.5 11.5h-3 M16.5 11.5h-3 M7 14.5 4.8 16.3 M13 14.5l2.2 1.8 M7.2 7.6 5 5.6 M12.8 7.6 15 5.6",
  book: "M4 4a2 2 0 012-2h10v14H6a2 2 0 00-2 2V4z M16 2v14",
  chat: "M3.5 4h13v9H8.5l-4 3.5V4z",
  check: "M4 10.5l4 4L16.5 6",
  cmp: "M10 2.5v15M3 6h4.5M3 10h4.5M3 14h4.5M12.5 6H17M12.5 10H17M12.5 14H17",
  cost: "M4 16.5V10M10 16.5V4M16 16.5V8",
  cube: "M10 2.5 16.5 6v8L10 17.5 3.5 14V6L10 2.5z M10 10l6.5-4M10 10 3.5 6M10 10v7.5",
  cursor: "M5 3l11 6.5-4.8 1.3L14 16l-2.3 1.2-2.7-5L5 15V3z",
  filter: "M3.5 4.5h13L11.5 10v5l-3 2v-7L3.5 4.5z",
  flow: "M6.5 9.2 13.5 5.6M6.5 10.8l7 3.6 M4.5 8a2 2 0 100 4 2 2 0 000-4z M15.5 3a2 2 0 100 4 2 2 0 000-4z M15.5 13a2 2 0 100 4 2 2 0 000-4z",
  grid: "M3 3h6v6H3z M11 3h6v6h-6z M3 11h6v6H3z M11 11h6v6h-6z",
  hist: "M4 10a6 6 0 116 6 M4 10H2M4 10l1.5 2M10 6.5V10l2.5 1.5",
  layers: "M10 3l7 3.8-7 3.7-7-3.7L10 3z M3 12.5l7 3.7 7-3.7",
  ruler: "M2.5 14 14 2.5l3.5 3.5L6 17.5 2.5 14z M6 10.5l1.5 1.5M8.5 8l1.5 1.5M11 5.5l1.5 1.5",
  search: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z M17 17l-4-4",
  send: "M3 10 17 3l-3.5 14L9.5 12 3 10z M9.5 12 17 3",
  star: "M10 2.8l2.2 4.5 4.9.7-3.6 3.4.9 4.9L10 14l-4.4 2.3.9-4.9L2.9 8l4.9-.7L10 2.8z",
  sun: "M10 6.6a3.4 3.4 0 100 6.8 3.4 3.4 0 000-6.8z M10 2v2M10 16v2M2 10h2M16 10h2M4.3 4.3l1.4 1.4M14.3 14.3l1.4 1.4M15.7 4.3l-1.4 1.4M5.7 14.3l-1.4 1.4",
  google: "M17.5 10.2c0-.6-.05-1.2-.16-1.7H10v3.3h4.2a3.6 3.6 0 01-1.56 2.36v1.96h2.52c1.48-1.36 2.34-3.36 2.34-5.92z M10 18c2.1 0 3.87-.7 5.16-1.88l-2.52-1.96c-.7.47-1.6.75-2.64.75-2.03 0-3.75-1.37-4.36-3.21H3.03v2.02A8 8 0 0010 18z M5.64 11.7a4.8 4.8 0 010-3.06V6.62H3.03a8 8 0 000 6.76l2.61-1.68z M10 5.16c1.15 0 2.18.4 2.99 1.17l2.24-2.24C13.86 2.83 12.1 2 10 2a8 8 0 00-6.97 4.02l2.61 2.02C6.25 6.2 7.97 5.16 10 5.16z",
};

/** Icoanele se desenează cu un sfert mai mari decât `s` scris la apel: la
 *  mărimile din cod (11–18) ieșeau prea mici lângă text. Un singur factor,
 *  aici, ca proporțiile dintre ele să rămână cele alese la fiecare loc. */
const SCARA_ICOANE = 1.25;
const px = (s: number) => Math.round(s * SCARA_ICOANE);

export function Ic({ n, s = 16 }: { n: keyof typeof PATHS | string; s?: number }) {
  return (
    <svg width={px(s)} height={px(s)} viewBox="0 0 20 20" fill="none" stroke="currentColor"
         strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d={PATHS[n] ?? ""} />
    </svg>
  );
}

/** Numele, în lockup-ul ales pentru antet (S2, 13.10.2026; planșa logoului,
 *  claude.ai/artifact/TstXAjttnpfqc4ey9GiJun): OPTIMUS în Michroma, spațiat,
 *  peste BUILD mai mic, între două linii scurte — fără semn. Semnul noului logo
 *  stă în favicon și în animația de generare (`Imprimanta`), unde are loc să se
 *  vadă; la înălțimea antetului s-ar fi citit ca trei linii. Culorile vin din
 *  `--logo-text` și `--logo-acc`: cerneală și teal-ul închis pe paginile
 *  deschise, iar pe antetul închis le schimbă `.top`. `size` e înălțimea
 *  rândului în care stă — 22 în antet, 26 pe paginile de intrare. */
export function Logo({ size = 22 }: { size?: number }) {
  return (
    <span className="logo" role="img" aria-label="Optimus Build"
          style={{ fontSize: Math.round(size * 13 / 22 * 10) / 10 }}>
      <span className="logo-nume" aria-hidden="true">OPTIMUS</span>
      <span className="logo-build" aria-hidden="true"><span>BUILD</span></span>
    </span>
  );
}

/** Steluța favoritei: conturul e același, umplerea spune starea.
 *
 *  Două icoane diferite ar fi două forme care „aproape" coincid, iar ochiul
 *  prinde diferența ca pe o mișcare — exact ce nu vrei la un buton care doar
 *  își schimbă starea. */
export function Stea({ plina = false, s = 18 }: { plina?: boolean; s?: number }) {
  return (
    <svg width={px(s)} height={px(s)} viewBox="0 0 20 20"
         fill={plina ? "currentColor" : "none"} stroke="currentColor"
         strokeWidth={1.4} strokeLinejoin="round">
      <path d="M10 2.8l2.2 4.5 4.9.7-3.6 3.4.9 4.9L10 14l-4.4 2.3.9-4.9L2.9 8l4.9-.7L10 2.8z" />
    </svg>
  );
}

export function Chip({ tone = "mut", children }:
                     { tone?: "ok" | "bad" | "amb" | "acc" | "mut"; children: ReactNode }) {
  return <span className={`chip c-${tone}`}>{children}</span>;
}
